<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<div id="parent" *ngIf="pdfDoc">
    <div id="toolbarViewer">
        <div id="toolbarViewerLeft" class="splitToolbarButton">
            <button class="toolbarButton pageUp hiddenSmallView" title="{{'pdfJsReader.previousPage' | translate}}" id="previous"
                    (click)="onPrevPage()">
                <span>{{'pdfJsReader.previous' | translate}}</span>
            </button>
            <div class="splitToolbarButtonSeparator hiddenSmallView"></div>
            <button class="toolbarButton pageDown hiddenSmallView" title="{{'pdfJsReader.nextPage' | translate}}" id="next" (click)="onNextPage()">
                <span data-l10n-id="next_label">{{'pdfJsReader.next' | translate}}</span>
            </button>
            <input type="number" id="pageNumber" class="toolbarField pageNumber" title="{{'pdfJsReader.page' | translate}}"
                   (keypress)="updatePage($event)" [value]="1">
            <span id="numPages" class="toolbarLabel">{{pdfDoc.numPages}}</span>
        </div>

        <div id="toolbarViewerMiddle" class="splitToolbarButton">
            <button id="outZoom" class="toolbarButton zoomOut hiddenSmallView" title="{{'pdfJsReader.zoomOut' | translate}}" (click)="zoomOut()">
                <span data-l10n-id="zoom_out_label">{{'pdfJsReader.zoomOut' | translate}}</span>
            </button>
            <div class="splitToolbarButtonSeparator hiddenSmallView"></div>
            <button id="inZoom" class="toolbarButton zoomIn hiddenSmallView" title="{{'pdfJsReader.zoomIn' | translate}}" (click)="zoomIn()">
                <span data-l10n-id="zoom_in_label">{{'pdfJsReader.zoomIn' | translate}}</span>
            </button>
            <span id="scaleSelectContainer" class="dropdownToolbarButton hiddenTinyView">
                <select id="scaleSelect" title="{{'pdfJsReader.zoom' | translate}}" [(ngModel)]="item" (ngModelChange)="zoomSelect()">
                    <option value="auto">Auto</option>
                    <option value="0.5">50%</option>
                    <option value="0.75">75%</option>
                    <option value="1">100%</option>
                    <option value="1.25">125%</option>
                    <option value="1.5">150%</option>
                    <option value="2">200%</option>
                    <option value="3">300%</option>
                    <option value="4">400%</option>
                </select>
            </span>
        </div>

        <div id="toolbarViewerRight">
            <button id="signatures" class="toolbarButton signature hiddenMediumView" title="{{'pdfJsReader.signatures' | translate}}"
                    (click)="toggleSignaturePanel()">
                <span data-l10n-id="signatures_label">{{'pdfJsReader.signatures' | translate}}</span>
            </button>
            <button class="toolbarButton download hiddenMediumView" id="download" title="{{'pdfJsReader.download' | translate}}"
                    (click)="download()">
                <span data-l10n-id="download_label">{{'pdfJsReader.download' | translate}}</span>
            </button>
        </div>
    </div>
    <div id="pdfViewerContainer">
        <div id="signaturesPanel">
            <!--            uib-accordion-->
            <div>
                <!-- Contains 1 signature -->
                <!--                uib-accordion-group in directive -->
                <ngb-accordion *ngFor="let signature of signaturesTab; let index = index" id="accordion-group-{{index}}">
                    <ngb-panel [title]="signature.shortCn">
                        <ng-template ngbPanelContent>
                            <div>
                                <dl class="signaturesDl">
                                    <dt class="signaturesDt">{{'pdfJsReader.date' | translate}}</dt>
                                    <dd class="signaturesDd" title="{{signature.timestamp}}">{{signature.timestamp}}</dd>
                                    <dt class="signaturesDt">{{'pdfJsReader.valid' | translate}}</dt>
                                    <dd class="signaturesDd">{{signature.valid}}</dd>
                                    <dt class="signaturesDt">{{'pdfJsReader.format' | translate}}</dt>
                                    <dd class="signaturesDd">{{signature.format}}</dd>
                                </dl>

                                <button id="detailCertificate" (click)="openCertificateDialog(signature)">
                                    {{'pdfJsReader.certificateDetails' | translate}}
                                </button>
                            </div>
                        </ng-template>
                    </ngb-panel>

                </ngb-accordion>
                <p id="noSignature" *ngIf="signaturesCount<=0">{{'pdfJsReader.noSignatures' | translate}}</p>
            </div>

        </div>

        <div (scroll)="updatePageNumberOnScroll()" id="pdfJsContainer">
            <span class="errorMsg" *ngIf="error.error">{{error.msg}}</span>
            <div *ngFor="let n of pages" class="canvasContainer">
                <canvas class="pdfCanvas" id="canvas{{n.value}}"></canvas>
                <div class="annotationLayer" id="annotationLayer{{n.value}}" (click)="onCanvasClick($event)"></div>
            </div>
        </div>
    </div>
</div>
